function stringTitleCase(str) {

	const toTitleCase = (str) => {
		str = str.toLowerCase().split(' ');
		for (var i = 0; i < str.length; i++) {
			str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
		}
		return str.join(' ')
	}

	const onlyOneWhiteSpace = str.split(' ')
		.filter(n => n).join(' ')

	const sentence = onlyOneWhiteSpace.split(' ')
		.map(function(word) {
			return word.replace(word[0], word[0].toUpperCase())
		})
	
		return toTitleCase(sentence.join(' '))

}
export default stringTitleCase